import React from 'react';

const Accordion = ({ expanded, toggle, children, id, additionalClass }) => {
  const dropdown = expanded ? 'dropdown-show' : 'dropdown-hide';

  return (
    <div
      className={`creation-form ui-accordion ${additionalClass || ''}`}
      role='tablist'
    >
      <h3
        id={id}
        className='accordion ui-accordion-header ui-state-default'
        role='tab'
        aria-controls={id + '-content'}
        aria-selected='false'
        aria-expanded={expanded}
        tabIndex='0'
        onClick={toggle}
      >
        <i
          className={
            'fa-solid fa-square-caret-' + (expanded ? 'up' : 'up open')
          }
        />
      </h3>
      <div
        className={`ui-accordion-content ${dropdown}`}
        id={id + '-content'}
        aria-labelledby='new-form-dropdown'
        role='tabpanel'
        aria-hidden={!expanded}
      >
        {children}
      </div>
    </div>
  );
};

export default Accordion;
